/**
 * 매장 방문 주문상태
 */
export enum NumRepairOrderStatus {
  /**
   * 예약취소
   */
  // CANCELED_ORDER = 0,
  /**
   * 결제완료
   */
  COMPLETED_PAYMENT = 1,
  /**
   * 주문확정
   */
  CONFIRMED_ORDER = 3,
  /**
   * 출고의뢰
   */
  REQUESTED_GOODS_ISSUE = 5,
  /**
   * 출고완료
   */
  COMPLETED_GOODS_ISSUE = 7,
  /**
   * 작업완료
   */
  COMPLETED_SERVICE = 9,
  /**
   * 구매확정
   */
  CONFIRMED_PURCHASE = 12,
}
